import React from "react";
import LaserCutting from "./LaserCutting";

export default function PlasmaCutting() {
  return <LaserCutting process="plasma" />;
}
